import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import io from 'socket.io-client';
import { Col, Row } from 'reactstrap';
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import AdminFooter from 'components/Footers/AdminFooter.js';
import Sidebar from 'components/Sidebar/Sidebar.js';
import { isExpired } from 'react-jwt';
import { getLogoURL } from '../../views/SystemParams/services/getLogoURL';
import ServiceAuth from '../../services/ServiceAUTH';
import { SocketAdmConversationProvider } from '../../hooks/useSocketAdmConversations';
import { SocketInternalChatProvider } from '../../hooks/useInternalChatSocket';
import { RequestUserProvider } from 'hooks/useUserContext';
import { ConversationChatTsConnectionSocketForMonitoringProvider } from '../../hooks/useSocketConversationChatTs';
import { FlexCaseBackEndConnectionSocketProvider } from 'hooks/useSocketFlexCaseBackend';
import { ConversationConnectionSocketForMonitoringProvider } from '../../hooks/useConversationConnectionSocketForMonitoring';
import routes from 'routes';
import { connect } from 'react-redux'; // useDispatch removed
import SideDrawer from './SideDrawer';
import {
  toggleSideDrawer,
  openSideDrawer
} from 'store/action/sideDrawerActions';
import { CustomFieldsContextProvider } from 'views/Protocol/form/context/CustomFieldsContext';
import { rolesStore } from 'views/Roles';
import { updateProgressImportBroadcastList } from 'store/action/broadcast-list-actions'; // Added import
import { useServerSentEvents } from 'hooks/useServerSentEvents';

function SseListener() {
  useServerSentEvents({})
  return null
}

class Admin extends React.Component {
  state = {
    sidenavOpen: true,
    rolesLoaded: false,
    image: null,
    answeringDialerCallData: null
  };

  socket = io(process.env.REACT_APP_PROXY_URL, {
    path: process.env.REACT_APP_CASE_SOCKET_PATH,
    transports: ['websocket'],
    upgrade: false
  });

  isValidExtension(eventData, currentExtension) {
    if (!eventData?.params || !eventData.extension) return false;
    return eventData.extension === currentExtension;
  }

  componentDidMount() {
    getLogoURL().then((source) => {
      this.setState({
        image: source
      });
    });

    if ((rolesStore.getRoles() || []).length > 0) {
      this.setState({ rolesLoaded: true });
    }

    window.addEventListener('rolesLoaded', this.updateRolesUser);

    this.socket.on('client_dialer_call_answered', (eventData) => {
      const extension = localStorage.getItem('currentLoggedInExtension');

      if (!this.isValidExtension(eventData, extension)) {
        console.warn(
          'Error: Extension does not match the current logged in extension.'
        );
        return;
      }

      this.setState({ answeringDialerCallData: eventData });
      this.props.openSideDrawer({
        answeringDialerCallData: eventData
      });
    });

    this.socket.on('client_external_screen_call_answered', (data) =>
      this.openExternalLink(data)
    );
    this.socket.on('progress-import-broadcast-list', (data) =>
      this.props.updateProgress(data)
    );
  }

  componentDidUpdate(e) {
    if (e.history.pathname !== e.location.pathname) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainContent.scrollTop = 0;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('rolesLoaded', this.updateRolesUser);
    this.socket.disconnect();
  }

  updateRolesUser = () => {
    this.setState({ rolesLoaded: true });
    this.forceUpdate();
  };

  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }

      let permission = false;

      if (prop.roles) {
        for (let i = 0; i < prop.roles.length; i++) {
          if (permission === true) break;

          const roles = rolesStore.getRoles() || [];

          for (let j = 0; j < roles.length; j++) {
            if (roles[j]) {
              if (
                prop.roles[i] === roles[j].role.toUpperCase() ||
                prop.roles[i] === 'ALL'
              ) {
                permission = true;
                break;
              }
            } else break;
          }
        }
      }

      if (prop.layout === '/admin' && permission === true) {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
            exact={prop.exact}
          />
        );
      } else {
        return null;
      }
    });
  };
  getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return 'Brand';
  };

  toggleSidenav = (e) => {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
    }
    this.setState({
      sidenavOpen: !this.state.sidenavOpen
    });
  };
  getNavbarTheme = () => {
    return this.props.location.pathname.indexOf(
      'admin/alternative-dashboard'
    ) === -1
      ? 'dark'
      : 'light';
  };

  registerLogoutByTokenExpired = async () => {
    const service = new ServiceAuth('logout');
    const userLogin = localStorage.getItem('login');

    try {
      const data = {
        logoutType: 'logout_por_token_expirado',
        login: userLogin
      };
      await service.create({ ...data });
      window.location.href = '/activelogout';
    } catch (err) {
      console.error('Error register logout by token expired', err);
    }
  };

  getMainContentColumnSize() {
    return this.props.isDrawerCollapsed ? '12' : '7';
  }

  getRedirect() {
    const rolesComplete = rolesStore.getRoles() || [];
    const roles = rolesComplete.map((role) => role.role);

    if (roles.includes('AGENT_DASHBOARD') && !roles.includes('DASHBOARD')) {
      return <Redirect from="*" to="/admin/dashboard/agent" />;
    }

    return <Redirect from="*" to="/admin/dashboard" />;
  }

  openExternalLink(data) {
    const { params } = data;
    const extension = localStorage.getItem('currentLoggedInExtension');
    if (
      params &&
      params.externalLink &&
      this.isValidExtension(data, extension)
    ) {
      window.open(params.externalLink, '_blank');
      return;
    }
    console.warn(
      'Link could not be opened! Check if the external link is valid or if the extension matches.'
    );
  }

  render() {
    const expired = isExpired(localStorage.getItem('token'));
    if (expired) {
      this.registerLogoutByTokenExpired();
    }
    return (
      <>
        <SseListener />
        <FlexCaseBackEndConnectionSocketProvider
          socketFlexCaseBackEnd={this.socket}
        >
          <ConversationChatTsConnectionSocketForMonitoringProvider>
            <ConversationConnectionSocketForMonitoringProvider>
              <SocketAdmConversationProvider>
                <SocketInternalChatProvider>
                  <RequestUserProvider>
                    <CustomFieldsContextProvider>
                      <Sidebar
                        {...this.props}
                        routes={routes}
                        toggleSidenav={this.toggleSidenav}
                        sidenavOpen={this.state.sidenavOpen}
                        logo={{
                          innerLink: '/admin/dashboard',
                          imgSrc: this.state.image,
                          imgAlt: '...'
                        }}
                      />
                      <div
                        className="main-content"
                        ref="mainContent"
                        onClick={this.closeSidenav}
                      >
                        <Row className="p-0 m-0">
                          <Col
                            md={this.getMainContentColumnSize()}
                            className={`p-0 m-0`}
                            style={{ transition: '0.2s' }}
                          >
                            <AdminNavbar
                              {...this.props}
                              theme={this.getNavbarTheme()}
                              toggleSidenav={this.toggleSidenav}
                              sidenavOpen={this.state.sidenavOpen}
                              brandText={this.getBrandText(
                                this.props.location.pathname
                              )}
                            />
                            {this.state.rolesLoaded ? (
                              <Switch>
                                {this.getRoutes(routes)}
                                {this.getRedirect()}
                              </Switch>
                            ) : (
                              <div className="d-flex justify-content-center align-items-center h-100">
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="sr-only">Carregando...</span>
                                </div>
                              </div>
                            )}
                          </Col>
                          <Col className="m-0 p-0">
                            <SideDrawer />
                          </Col>
                          <AdminFooter />
                        </Row>
                      </div>
                      {this.state.sidenavOpen ? (
                        <div
                          className="backdrop d-xl-none"
                          onClick={this.toggleSidenav}
                        />
                      ) : null}
                    </CustomFieldsContextProvider>
                  </RequestUserProvider>
                </SocketInternalChatProvider>
              </SocketAdmConversationProvider>
            </ConversationConnectionSocketForMonitoringProvider>
          </ConversationChatTsConnectionSocketForMonitoringProvider>
        </FlexCaseBackEndConnectionSocketProvider>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isDrawerCollapsed: state.sideDrawer.isDrawerCollapsed
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    openSideDrawer: (data) =>
      dispatch(
        openSideDrawer({
          tabId: 1,
          ...data
        })
      ),
    toggleSideDrawer: (value) => dispatch(toggleSideDrawer()),
    updateProgress: (data) => dispatch(updateProgressImportBroadcastList(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
